import type { DialogueDefinition } from '../../domain/types';

export const soldierIntroDialogue: DialogueDefinition = {
  id: 'soldier-intro',
  startNodeId: 'opening',
  fictionLabel: 'Fiktiv spilramme baseret på den historiske periode.',
  nodes: [
    {
      id: 'opening',
      speaker: 'Spiller',
      text: 'Hvad laver du?',
      nextNodeId: 'soldier-answer',
    },
    {
      id: 'soldier-answer',
      speaker: 'Soldaten',
      text: 'Jeg efterlader et lille spor. Noget, der måske stadig findes, når vi er væk.',
      choices: [
        {
          id: 'ask-for-knife',
          text: 'Må jeg få kniven?',
          nextNodeId: 'knife-in-use',
        },
        {
          id: 'leave-him',
          text: 'Jeg lader dig arbejde videre.',
          nextNodeId: 'goodbye',
        },
      ],
    },
    {
      id: 'knife-in-use',
      speaker: 'Soldaten',
      text: 'Nej. Jeg bruger kniven.',
      end: true,
    },
    {
      id: 'goodbye',
      speaker: 'Soldaten',
      text: 'Skoven har god tid. Det har vi andre knap så meget af.',
      end: true,
    },
  ],
};

export const soldierEatingDialogue: DialogueDefinition = {
  id: 'soldier-eating',
  startNodeId: 'eating',
  fictionLabel: 'Fiktiv spilramme baseret på den historiske periode.',
  nodes: [
    {
      id: 'eating',
      speaker: 'Soldaten',
      text: 'Tak. Jeg havde næsten glemt, hvor sulten jeg var.',
      end: true,
    },
  ],
};

export const soldierAfterKnifeDialogue: DialogueDefinition = {
  id: 'soldier-after-knife',
  startNodeId: 'reminder',
  fictionLabel: 'Fiktiv spilramme baseret på den historiske periode.',
  nodes: [
    {
      id: 'reminder',
      speaker: 'Soldaten',
      text: 'Tak for madpakken. Pas godt på kniven.',
      end: true,
    },
  ],
};

export const dialogues: Record<string, DialogueDefinition> = {
  [soldierIntroDialogue.id]: soldierIntroDialogue,
  [soldierEatingDialogue.id]: soldierEatingDialogue,
  [soldierAfterKnifeDialogue.id]: soldierAfterKnifeDialogue,
};
